export const RESTAURANT = {
  name: "Casa Fortuna",
  tagline: { it: "Ristorante · Cicchetteria · Mestre", en: "Restaurant · Cicchetteria · Mestre", de: "Restaurant · Cicchetteria · Mestre" },
  address: "Corte Bettini 14, Mestre (VE)",
  phone: "041 943244",
  closedDays: [1, 2],
  lunch: ["12:00", "12:30", "13:00", "13:30", "14:00"],
  dinner: ["19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00"],
};

export const LANGS = [
  { id: "it", label: "IT", name: "Italiano" },
  { id: "en", label: "EN", name: "English" },
  { id: "de", label: "DE", name: "Deutsch" },
];

export const UI = {
  it: {
    menu: "Il menù", categories: "Categorie", filters: "Filtri", glutenFree: "Senza glutine",
    noShellfish: "Senza crostacei", noDairy: "Senza latticini", allergens: "Allergeni", chef: "Dello chef",
    classic: "Classico veneziano", empty: "Nessun piatto con questi filtri.", prices: "Prezzi indicativi, IVA inclusa",
    call: "Chiama", book: "Prenota un tavolo", open: "Aperto oggi 10–15 · 17:30–23", closed: "Chiuso lunedì e martedì",
  },
  en: {
    menu: "The menu", categories: "Categories", filters: "Filters", glutenFree: "Gluten-free",
    noShellfish: "No shellfish", noDairy: "Dairy-free", allergens: "Allergens", chef: "Chef's pick",
    classic: "Venetian classic", empty: "No dishes match these filters.", prices: "Indicative prices, VAT included",
    call: "Call", book: "Book a table", open: "Open today 10–15 · 17:30–23", closed: "Closed Monday & Tuesday",
  },
  de: {
    menu: "Die Speisekarte", categories: "Kategorien", filters: "Filter", glutenFree: "Glutenfrei",
    noShellfish: "Ohne Krustentiere", noDairy: "Laktosefrei", allergens: "Allergene", chef: "Empfehlung des Chefs",
    classic: "Venezianischer Klassiker", empty: "Keine Gerichte mit diesen Filtern.", prices: "Richtpreise inkl. MwSt.",
    call: "Anrufen", book: "Tisch reservieren", open: "Heute geöffnet 10–15 · 17:30–23", closed: "Montag & Dienstag geschlossen",
  },
};

export const ALLERGENS = {
  1: { it: "Glutine", en: "Gluten", de: "Gluten" },
  2: { it: "Crostacei", en: "Crustaceans", de: "Krebstiere" },
  3: { it: "Uova", en: "Eggs", de: "Eier" },
  4: { it: "Pesce", en: "Fish", de: "Fisch" },
  7: { it: "Latte", en: "Milk", de: "Milch" },
  8: { it: "Frutta a guscio", en: "Nuts", de: "Schalenfrüchte" },
  12: { it: "Solfiti", en: "Sulphites", de: "Sulfite" },
  14: { it: "Molluschi", en: "Molluscs", de: "Weichtiere" },
};

export const CATEGORIES = [
  { id: "antipasti", it: "Cicchetti & Antipasti", en: "Cicchetti & Starters", de: "Cicchetti & Vorspeisen" },
  { id: "primi", it: "Primi", en: "Pasta", de: "Pasta" },
  { id: "secondi", it: "Secondi di pesce", en: "Fish mains", de: "Fisch-Hauptgerichte" },
  { id: "dolci", it: "Dolci della casa", en: "Homemade desserts", de: "Hausgemachte Desserts" },
];

const IMG = {
  clams: "https://images.unsplash.com/photo-1632778129004-f142ce499b3e?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  mussels: "https://images.unsplash.com/photo-1611464357429-a34ac648a5e9?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  seafood: "https://images.unsplash.com/photo-1578935149228-66b184c83e69?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  shrimp: "https://images.unsplash.com/photo-1619290462943-e21b611bb772?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  tiramisu: "https://images.unsplash.com/photo-1768225385872-03945d45a0d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  dessert: "https://images.unsplash.com/photo-1712262582493-01aa9ec5c7f8?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  fish: "https://images.unsplash.com/photo-1737140789642-9788a3388494?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
  grilled: "https://images.unsplash.com/photo-1532550907401-a500c9a57435?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
};

export const DISHES = [
  {
    id: "saor", cat: "antipasti", price: 12, allergens: [4, 12], tags: ["classic", "gf"], img: IMG.seafood,
    name: { it: "Sarde in saor", en: "Sardines in saor", de: "Sardinen in Saor" },
    desc: {
      it: "Sarde fritte marinate con cipolla bianca, uvetta e pinoli. La ricetta veneziana più antica.",
      en: "Fried sardines marinated with white onion, raisins and pine nuts. Venice's oldest recipe.",
      de: "Frittierte Sardinen, mariniert mit weißer Zwiebel, Rosinen und Pinienkernen. Venedigs ältestes Rezept.",
    },
  },
  {
    id: "baccala", cat: "antipasti", price: 13, allergens: [4, 7], tags: ["classic", "gf"], img: IMG.shrimp,
    name: { it: "Baccalà mantecato con polenta", en: "Creamed cod with polenta", de: "Baccalà mantecato mit Polenta" },
    desc: {
      it: "Stoccafisso montato a mano con olio extravergine, servito su polenta bianca grigliata.",
      en: "Hand-whipped stockfish with extra virgin olive oil on grilled white polenta.",
      de: "Von Hand aufgeschlagener Stockfisch mit Olivenöl auf gegrillter weißer Polenta.",
    },
  },
  {
    id: "antipasto", cat: "antipasti", price: 18, allergens: [1, 2, 4, 14], tags: ["chef"], img: IMG.mussels,
    name: { it: "Antipasto «Casa Fortuna»", en: "«Casa Fortuna» starter", de: "Vorspeise «Casa Fortuna»" },
    desc: {
      it: "Selezione del giorno di crudi, cotti e cicchetti di laguna scelti dallo chef Tiziano.",
      en: "Daily selection of raw, cooked and lagoon cicchetti chosen by chef Tiziano.",
      de: "Tagesauswahl an rohen, gekochten und Lagunen-Cicchetti, ausgewählt von Chef Tiziano.",
    },
  },
  {
    id: "cappesante", cat: "antipasti", price: 16, allergens: [1, 7, 14], tags: [], img: IMG.seafood,
    name: { it: "Cappesante gratinate", en: "Gratinated scallops", de: "Überbackene Jakobsmuscheln" },
    desc: {
      it: "Nella loro conchiglia, con pane profumato alle erbe e burro chiarificato.",
      en: "In their shell, with herb breadcrumbs and clarified butter.",
      de: "In der Schale, mit Kräuterbröseln und geklärter Butter.",
    },
  },
  {
    id: "tagliatelle", cat: "primi", price: 18, allergens: [1, 2, 3], tags: ["chef"], img: IMG.shrimp,
    name: {
      it: "Tagliatelle scampi, gamberi, zucchine e zafferano",
      en: "Tagliatelle with langoustines, prawns, courgette & saffron",
      de: "Tagliatelle mit Scampi, Garnelen, Zucchini & Safran",
    },
    desc: {
      it: "Pasta fresca all'uovo tirata in casa, crostacei dell'Adriatico e zafferano in pistilli.",
      en: "Homemade fresh egg pasta, Adriatic shellfish and saffron threads.",
      de: "Hausgemachte frische Eiernudeln, Adria-Krustentiere und Safranfäden.",
    },
  },
  {
    id: "spaghetti", cat: "primi", price: 16, allergens: [1, 4, 14], tags: ["classic"], img: IMG.clams,
    name: {
      it: "Spaghetti vongole veraci, broccoli e acciughe",
      en: "Spaghetti with clams, broccoli & anchovies",
      de: "Spaghetti mit Venusmuscheln, Brokkoli & Sardellen",
    },
    desc: {
      it: "Vongole veraci di laguna saltate con aglio, broccoletti e acciuga del Cantabrico.",
      en: "Lagoon clams sautéed with garlic, broccoli and Cantabrian anchovy.",
      de: "Lagunen-Venusmuscheln mit Knoblauch, Brokkoli und kantabrischer Sardelle.",
    },
  },
  {
    id: "gnocchetti", cat: "primi", price: 17, allergens: [1, 2, 3, 7], tags: [], img: IMG.mussels,
    name: { it: "Gnocchetti granseola e asparagi verdi", en: "Gnocchetti with spider crab & green asparagus", de: "Gnocchetti mit Seespinne & grünem Spargel" },
    desc: {
      it: "Gnocchetti di patate, polpa di granseola e punte di asparago di Bassano.",
      en: "Potato gnocchetti, spider crab meat and Bassano asparagus tips.",
      de: "Kartoffel-Gnocchetti, Seespinnenfleisch und Spargelspitzen aus Bassano.",
    },
  },
  {
    id: "seppie", cat: "secondi", price: 19, allergens: [14], tags: ["classic", "gf"], img: IMG.seafood,
    name: { it: "Seppie nostrane alla veneziana (nere)", en: "Venetian-style cuttlefish in ink", de: "Venezianischer Tintenfisch in Tinte" },
    desc: {
      it: "Seppie di Chioggia cotte nel loro nero, con polenta bianca morbida.",
      en: "Chioggia cuttlefish cooked in their own ink, with soft white polenta.",
      de: "Tintenfisch aus Chioggia in eigener Tinte, mit weicher weißer Polenta.",
    },
  },
  {
    id: "rombo", cat: "secondi", price: 26, allergens: [4], tags: ["chef", "gf"], img: IMG.fish,
    name: {
      it: "Rombo al forno con patate, olive taggiasche e pomodorini",
      en: "Baked turbot with potatoes, Taggiasca olives & cherry tomatoes",
      de: "Steinbutt aus dem Ofen mit Kartoffeln, Taggiasca-Oliven & Kirschtomaten",
    },
    desc: {
      it: "Rombo intero del giorno, al forno. In stagione anche con porcini.",
      en: "Whole turbot of the day, oven baked. With porcini in season.",
      de: "Ganzer Steinbutt des Tages, im Ofen gebacken. Saisonal mit Steinpilzen.",
    },
  },
  {
    id: "orata", cat: "secondi", price: 22, allergens: [4], tags: ["gf"], img: IMG.grilled,
    name: { it: "Orata in crosta di patate e olive taggiasche", en: "Sea bream in potato & Taggiasca olive crust", de: "Dorade in Kartoffel-Oliven-Kruste" },
    desc: {
      it: "Filetto di orata avvolto in sfoglie di patata croccante, olive e timo.",
      en: "Sea bream fillet wrapped in crispy potato slices, olives and thyme.",
      de: "Doradenfilet in knusprigen Kartoffelscheiben, Oliven und Thymian.",
    },
  },
  {
    id: "tiramisu", cat: "dolci", price: 7, allergens: [1, 3, 7], tags: ["classic"], img: IMG.tiramisu,
    name: { it: "Tiramisù della casa", en: "Homemade tiramisù", de: "Hausgemachtes Tiramisù" },
    desc: {
      it: "Produzione propria, senza preparati. Savoiardi, mascarpone e caffè della moka.",
      en: "Made in-house, no mixes. Ladyfingers, mascarpone and moka coffee.",
      de: "Hausgemacht, ohne Fertigmischungen. Löffelbiskuits, Mascarpone und Mokka-Kaffee.",
    },
  },
  {
    id: "zabaione", cat: "dolci", price: 7, allergens: [1, 3, 7, 12], tags: ["classic"], img: IMG.dessert,
    name: { it: "Zabaione, panna e baicoli", en: "Zabaione, cream & baicoli", de: "Zabaione, Sahne & Baicoli" },
    desc: {
      it: "Zabaione caldo al Marsala con i biscotti secchi della tradizione veneziana.",
      en: "Warm Marsala zabaione with Venice's traditional dry biscuits.",
      de: "Warmer Marsala-Zabaione mit den traditionellen venezianischen Keksen.",
    },
  },
  {
    id: "crostata", cat: "dolci", price: 7, allergens: [1, 3, 7], tags: [], img: IMG.dessert,
    name: { it: "Crostata all'arancio caramellato", en: "Caramelised orange tart", de: "Tarte mit karamellisierter Orange" },
    desc: {
      it: "Frolla friabile, crema all'arancio e fette di arancia caramellata.",
      en: "Crumbly shortcrust, orange cream and caramelised orange slices.",
      de: "Mürbeteig, Orangencreme und karamellisierte Orangenscheiben.",
    },
  },
  {
    id: "cassata", cat: "dolci", price: 7, allergens: [1, 3, 7, 8], tags: [], img: IMG.tiramisu,
    name: { it: "Cassata siciliana", en: "Sicilian cassata", de: "Sizilianische Cassata" },
    desc: {
      it: "Ricotta di pecora, pan di Spagna, pasta di mandorle e frutta candita.",
      en: "Sheep's ricotta, sponge cake, marzipan and candied fruit.",
      de: "Schafsricotta, Biskuit, Marzipan und kandierte Früchte.",
    },
  },
];
